document.addEventListener('DOMContentLoaded', function () {
  var written_reviews = new window.Splide('.written-reviews-slider .splide', {
    type: 'loop',
    autoplay: false,
    loop: true,
    arrows: true,
    pagination: true,
    snap: true,
    drag: 'free',
    focus: 'center',
    autoHeight: true,
    breakpoints: {
      480: {
        pagination: true,
        arrows: true,
        focus: 'center',
        autoHeight: true,
      },
    },
  });
  var heightMap = {};
  document.querySelectorAll('.written-reviews-slider .splide .splide__slide').forEach(function (e) {
    e.style.maxHeight = 0;
  });
  written_reviews.on('mounted', function () {
    var i = 0;
    document.querySelectorAll('.written-reviews-slider .splide .splide__slide').forEach(function (e) {
      if (!e.classList.contains('splide__slide--clone')) {
        heightMap[i] = e.scrollHeight;
        i++;
      }
    });
  });
  written_reviews.on('active', function (e) {
    // or e.index for non loop sliders
    var maxHeight = heightMap[e.index] + "px";
    e.slide.querySelector(".multicolumn-card").style.background = "#f3efea";
    e.slide.style.maxHeight = maxHeight;
    e.slide.parentElement.style.maxHeight = maxHeight;
    e.slide.parentElement.style.transition = "all 0.2s ease-in-out";
  });

  written_reviews.mount();
});
